var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { validateStatus } from "../../../constants/DataSource.constants.js";
var FilterOrSearch = /* @__PURE__ */ ((FilterOrSearch2) => {
  FilterOrSearch2["Filter"] = "Filter";
  FilterOrSearch2["Search"] = "Search";
  return FilterOrSearch2;
})(FilterOrSearch || {});
const DataSourceListConstants = {
  SET_USER_CONTEXT: "dataSourceList/command/SET_USER_CONTEXT",
  SET_PARTIAL_USER_CONTEXT: "dataSourceList/command/SET_PARTIAL_USER_CONTEXT"
};
const getDefaultState = () => {
  return {
    userContext: {
      showStatus: [validateStatus.ValidateSuccess, validateStatus.ValidateFailed, validateStatus.Unknown],
      showAdditionalProps: null,
      filter: null,
      search: null,
      filterOrSearch: "Search"
      /* Search */
    }
  };
};
const setPartialUserContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    userContext: __spreadValues(__spreadValues({}, state.userContext), actionResult.payload)
  });
};
function setPartialUserContextFunc(userContext) {
  return {
    type: DataSourceListConstants.SET_PARTIAL_USER_CONTEXT,
    payload: userContext
  };
}
const setUserContext = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    userContext: actionResult.payload
  });
};
function setUserContextFunc(userContext) {
  return {
    type: DataSourceListConstants.SET_USER_CONTEXT,
    payload: userContext
  };
}
const DataSourceListReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case DataSourceListConstants.SET_PARTIAL_USER_CONTEXT:
      return setPartialUserContext(state, actionResult);
    case DataSourceListConstants.SET_USER_CONTEXT:
      return setUserContext(state, actionResult);
    default:
      return state;
  }
};
export {
  DataSourceListConstants,
  DataSourceListReducer,
  FilterOrSearch,
  DataSourceListReducer as default,
  getDefaultState,
  setPartialUserContextFunc,
  setUserContext,
  setUserContextFunc
};
//# sourceMappingURL=DataSourceListFilter.ducks.js.map
